import React, { createContext, useContext, useState, useCallback } from 'react';

const TourContext = createContext();

export const TourProvider = ({ children }) => {
  const [tourSteps, setTourSteps] = useState(null);   // array de passos quando ativo
  const [onTourFinish, setOnTourFinish] = useState(null);

  // Inicia o tour com os passos fornecidos e um callback de conclusão
  const startTour = useCallback((steps, onFinish) => {
    setTourSteps(steps);
    setOnTourFinish(() => onFinish || null);
  }, []);

  const stopTour = useCallback(() => {
    setTourSteps(null);
    setOnTourFinish(null);
  }, []);

  return (
    <TourContext.Provider value={{ tourSteps, onTourFinish, startTour, stopTour }}>
      {children}
    </TourContext.Provider>
  );
};

export const useTour = () => useContext(TourContext);
